/* SS — Klaviyo « Back in stock »
   Voir snippets/ss-klaviyo-bis.liquid pour le contexte.
   Inscription via l'API client de Klaviyo (back-in-stock-subscriptions),
   variante Shopify courante lue dans le formulaire produit. */
(function () {
  if (window.__ssKlaviyoBis) return;
  window.__ssKlaviyoBis = true;

  var cfg = window.SS_KLAVIYO_BIS;
  if (!cfg || !cfg.account) return;

  var modal = document.getElementById('ss-bis-modal');
  if (!modal) return;

  var form = modal.querySelector('[data-ss-bis-form]');
  var input = modal.querySelector('#ss-bis-email');
  var submit = modal.querySelector('[data-ss-bis-submit]');
  var message = modal.querySelector('[data-ss-bis-message]');
  var lastTrigger = null;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function currentVariantId() {
    var fromUrl = new URLSearchParams(location.search).get('variant');
    var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (field && field.value) || fromUrl || '';
  }

  function setMessage(text, type) {
    if (!message) return;
    message.textContent = text || '';
    message.hidden = !text;
    message.classList.toggle('ss-bis-modal__message--error', type === 'error');
    message.classList.toggle('ss-bis-modal__message--success', type === 'success');
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    setMessage('');
    if (submit) submit.disabled = false;
    if (form) form.hidden = false;
    modal.hidden = false;
    modal.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { input && input.focus(); }, 30);
  }

  function close() {
    modal.removeAttribute('open');
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function subscribe(email, variantId) {
    var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.account);
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, locale: cfg.locale || undefined }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        accept: 'application/vnd.api+json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      return res;
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ss-bis-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger);
      return;
    }
    if (e.target.closest('[data-ss-bis-close]')) {
      e.preventDefault();
      close();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.hasAttribute('open')) close();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input && input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        setMessage(cfg.strings.invalidEmail, 'error');
        input && input.focus();
        return;
      }
      var variantId = currentVariantId();
      if (!variantId) {
        setMessage(cfg.strings.error, 'error');
        return;
      }
      if (submit) submit.disabled = true;
      setMessage('');
      subscribe(email, variantId)
        .then(function () {
          setMessage(cfg.strings.success, 'success');
          if (input) input.value = '';
        })
        .catch(function (err) {
          console.warn('[ss-klaviyo-bis]', err);
          setMessage(cfg.strings.error, 'error');
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  /* Barre d'ajout collante masquée quand la variante est épuisée */
  if (cfg.hideSticky) {
    document.documentElement.classList.add('ss-bis-hide-sticky');
    var sync = function () {
      var main = document.querySelector('form[action*="/cart/add"]');
      var scope = (main && main.closest('.shopify-section')) || document;
      document.documentElement.classList.toggle('ss-bis-active', !!scope.querySelector('[data-ss-bis-flag]'));
    };
    sync();
    new MutationObserver(function () { sync(); }).observe(document.body, { childList: true, subtree: true });
  }
})();
